import type { ChangeClassificationRow } from '../../releasegovernance/framework';

type Props = { items?: ChangeClassificationRow[] };

export function ChangeClassificationPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.class} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.class}</p>
            <p className="text-lg font-semibold text-brand-600">{item.count}</p>
          </div>
          <p className="mt-1 text-xs text-slate-500">{item.status}</p>
        </div>
      ))}
    </div>
  );
}
